<my-admin-save-bar i18n-title title="Advanced configuration" (save)="save()" [form]="form" [formErrors]="formErrors" [validationMessages]="validationMessages"></my-admin-save-bar>

<form [formGroup]="form" id="admin-config-form">

  <div class="pt-two-cols">

    <div class="title-col">
      <h2 i18n>CACHE</h2>
      <div i18n class="inner-form-description">
        Some files are not federated, and fetched when necessary. Define their caching policies.
      </div>
    </div>
  </div>

  <div class="pt-two-cols mt-4">
    <div class="title-col">
      <h2 i18n>TWITTER/X</h2>

      <div i18n class="inner-form-description">
        Extra configuration required by Twitter/X. All other social media (Facebook, Mastodon, etc.) are supported out of the box.
      </div>
    </div>

    <div class="content-col">

      <ng-container formGroupName="services">
        <ng-container formGroupName="twitter">

          <div class="form-group">
            <label for="servicesTwitterUsername" i18n>Your Twitter/X username</label>

            <div class="form-group-description">
              <p i18n class="mb-0">Indicates the Twitter/X account for the website or platform where the content was published.</p>

              <p i18n>This is just an extra information injected in PeerTube HTML that is required by Twitter/X. If you don't have a Twitter/X account, just leave the default value.</p>
            </div>

            <input
              type="text" id="servicesTwitterUsername" class="form-control"
              formControlName="username" [ngClass]="{ 'input-error': formErrors.services.twitter.username }"
              >

            @if (formErrors.services.twitter.username) {
              <div class="form-error" role="alert">{{ formErrors.services.twitter.username }}</div>
            }
          </div>

        </ng-container>
      </ng-container>

    </div>
  </div>
</form>
